import React from 'react'
import PageForm from 'components/pageForm/PageForm.js'
import HeaderVivier from './components/header/header.vivier.js'
import BodyFicheVivier from './components/content/body.fiche.vivier.js'

function FicheVivier() {
  return (
    <>
    <PageForm>
        <BodyFicheVivier/>
    </PageForm>
</>
  )
}

export default FicheVivier